export default __webpack_public_path__ + "static/media/featured-video.ae75c14f.mp4";